import { ApiHelper } from '../utils/ApiHelper'
import { SubmissionError } from 'redux-form'
import AnalyticsHelper from '../utils/AnalyticsHelper'
import CloudEvent from '../utils/CloudEvent'

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST'
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS'
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE'

export function updateUser(values) {
  return (dispatch, getState) => {
    dispatch({type: 'UPDATE_USER_REQUEST', values})
    return ApiHelper
      .updateUser(values)
      .then(json => {
          // TODO 201 check or catch? how to handle err
          // Note from Gabo -> handle error with ant's message component if response is not 201
          if (json.status != 201) console.error(json)

          var properties = {}
          properties[CloudEvent.Email] = json.data.email
          properties[CloudEvent.Phone] = json.data.mobile
          properties[CloudEvent.FirstName] = json.data.name
          properties[CloudEvent.LastName] = json.data.last
          properties[CloudEvent.PushNotificationsEnabled] = json.data.push_notifications_enabled
          properties[CloudEvent.WeeklyReportEnabled] = json.data.weekly_report_enabled
          properties[CloudEvent.MonthlyReportEnabled] = json.data.monthly_report_enabled
          if (json.data.income_sources.length > 0) {
              properties[CloudEvent.IncomeSources] = json.data.income_sources
          }
          AnalyticsHelper.addPeopleProperty(json.data.token_id, properties)

          dispatch({
            type: 'UPDATE_USER_SUCCESS',
            user: json.data
          })

        return json

      })

      // .catch((error) => {
      //
      //   dispatch({
      //     type: 'UPDATE_USER_FAILURE',
      //     error
      //   })
      //
      //   throw new SubmissionError({
      //     // TODO error object could have the failing field which would render
      //     // an inline error and style with red border e.g.
      //     //   verify_password: 'Wrong password',
      //     ...error.data,
      //     _error: error.data.message
      //   })
      //
      // });
  }
}



// WEBPACK FOOTER //
// ./src/account/actions.js